import builtins from './templates.json'
import { BANNER_IMAGE } from './templateBuilder.js'
import { BANNER_IMAGE_VARIABLE } from './bannerFills.js'
import { getNormalizedTemplate } from './templateVariants.js'

const URL_QUERY_OR_FRAGMENT_PATTERN = /[?#]/

export const RESTYLE_PICTURE = 'picture'
export const RESTYLE_CUSTOM_CODE = 'custom_code'

const RESTYLE_URL = /url\(\s*["']?([^"')]+)/gi

const shippedArtwork = new Set()
const shippedVariantCSS = new Set([''])
for (const template of builtins) {
  const add = (artwork) => {
    shippedArtwork.add(`${artwork.htmlCode ?? ''}\u0000${artwork.cssCode ?? ''}`)
    for (const variant of Object.values(artwork.variants ?? {})) {
      shippedVariantCSS.add(variant.cssCode ?? '')
    }
  }
  add(template)
  for (const revision of template.previousArtwork ?? []) add(revision)
}

const hasPictureURL = (value) => {
  if (typeof value !== 'string') return false
  for (const match of value.matchAll(RESTYLE_URL)) {
    const argument = match[1].trim().toLowerCase()
    const path = argument.split(URL_QUERY_OR_FRAGMENT_PATTERN, 1)[0]
    if (argument.startsWith('data:image/svg') || path.endsWith('.woff') || path.endsWith('.woff2')) continue
    return true
  }
  return false
}

const variableHasKey = (variables, key) => variables?.some((variable) => variable?.key === key) === true

const builderHasAddedCSS = (builder) => {
  const css = builder?.css
  return Boolean(css && typeof css === 'object' && ['shared', 'light', 'dark'].some((key) => typeof css[key] === 'string' && css[key].trim() !== ''))
}

const templateHasPicture = (template) => {
  if (template.builder?.banner === BANNER_IMAGE) return true
  if (variableHasKey(template.cssVars, BANNER_IMAGE_VARIABLE)) return true
  for (const variant of Object.values(template.variants ?? {})) {
    if (variableHasKey(variant.cssVars, BANNER_IMAGE_VARIABLE)) return true
  }
  if (hasPictureURL(template.cssCode)) return true
  for (const variable of template.cssVars ?? []) {
    if (hasPictureURL(variable.value)) return true
  }
  for (const variant of Object.values(template.variants ?? {})) {
    if (hasPictureURL(variant.cssCode)) return true
    for (const variable of variant.cssVars ?? []) {
      if (hasPictureURL(variable.value)) return true
    }
  }
  return false
}

export function restyleIncompatibility(template) {
  const normalized = getNormalizedTemplate(template)
  if (!normalized || normalized.isFallback || normalized.id === 't-default') return ''
  if (templateHasPicture(normalized)) return RESTYLE_PICTURE
  if (normalized.builder) {
    if (builderHasAddedCSS(normalized.builder) || normalized.builder.code) return RESTYLE_CUSTOM_CODE
    return ''
  }
  if (!shippedArtwork.has(`${normalized.htmlCode ?? ''}\u0000${normalized.cssCode ?? ''}`)) return RESTYLE_CUSTOM_CODE
  for (const variant of Object.values(normalized.variants ?? {})) {
    if (!shippedVariantCSS.has(variant.cssCode ?? '')) return RESTYLE_CUSTOM_CODE
  }
  return ''
}
